export async function ayarlariListele(istemci) {
    return istemci.istek('/ayarlar');
}
export async function ayarSetle(istemci, giris) {
    return istemci.istek('/ayarlar', {
        method: 'PUT',
        body: JSON.stringify(giris),
    });
}
function denetimDs(s) {
    const p = new URLSearchParams();
    if (s.sayfa)
        p.set('sayfa', String(s.sayfa));
    if (s.boyut)
        p.set('boyut', String(s.boyut));
    if (s.yapanKullaniciId)
        p.set('yapanKullaniciId', s.yapanKullaniciId);
    if (s.eylem)
        p.set('eylem', s.eylem);
    if (s.kaynak)
        p.set('kaynak', s.kaynak);
    if (s.baslangicTen)
        p.set('baslangicTen', s.baslangicTen);
    if (s.baslangicAKadar)
        p.set('baslangicAKadar', s.baslangicAKadar);
    const q = p.toString();
    return q ? `?${q}` : '';
}
export async function denetimKayitlariniListele(istemci, sorgu = {}) {
    return istemci.istek(`/denetim${denetimDs(sorgu)}`);
}
//# sourceMappingURL=ayarlar.js.map